import React, {Component} from 'react';

import '../Finish/styles/finish.scss';

export default class ErrorPayment extends Component {
  render() {
    return(
      <div className="finish">
        <div className="container">
          <div className="finish__img">
            <img src={require('../../static/images/icons/finish-error.svg')} alt="error"/>
          </div>
          <div className="finish__text">
            <h3>Что-то пошло не&nbsp;так!</h3>
            <p>Что-то пошло не&nbsp;так, но&nbsp;твои данные направлены менеджеру. Мы&nbsp;свяжемся с&nbsp;тобой в&nbsp;ближайшее время.</p>
          </div>
          <div className="finish__btn">
            <a href="/" className="btn _type-2">Вернуться на главную</a>
          </div>
        </div>
      </div>
    )
  }
}
